
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58.3 58.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.7.2h-25C7.5.2.1 7.5.1 16.6v25c0 9.1 7.4 16.5 16.5 16.5h7.1V37.6h-6.9v-7.7h6.9V23c0-2.3.9-6 2.9-7.9 2.3-2.3 4.8-3.2 7.8-3.2 1.9 0 7.2.2 7.2.2V20h-4.9c-1.7.1-2.7 2-2.8 3.1V30h7.7l-1 7.7h-6.9v20.6h8c9.1 0 16.5-7.4 16.5-16.5v-25C58.1 7.5 50.8.2 41.7.2z","fill":"#1877f2"}})])
          )
        }
      }
    